'use strict';

/**
 * @ngdoc function
 * @name thothAppApp.controller:ActivityService
 * @description
 * # ActivityService
 * Controller of the thothAppApp
 */
angular.module('thothApp.services')
  .factory('Activity', ['$http', 'domain', 'BaseService', function ($http, domain, BaseService) {
    var BASE_ACTIVITY_URL = domain.name + '/api/v1/activities/';
    var baseService = new BaseService();

    baseService.initialize({
      baseUrl: BASE_ACTIVITY_URL,
      baseModelName: 'activity'
    });

    baseService.getWeekActivities = function(employeeId, startOfWeek, endOfWeek) {
      return $http.get(BASE_ACTIVITY_URL, {
        params: {
          by_begins_at: { start_date: startOfWeek, end_date: endOfWeek },
          by_employee: employeeId
        }
      });
    };

    baseService.downloadActivities = function(params) {
      return $http.get(domain.name + '/api/v1/activities.csv/', params, {
        params: params.by_begins_at,
        timeout: 300000,
      });
    };

    baseService.downloadPersonalActivities = function(params) {
      return $http.get(domain.name + '/api/v1/activities/download_personal_report.csv', params, {
        params: params.by_begins_at,
      });
    };

    baseService.downloadFormatCsv = function() {
      return $http.get(domain.name + '/api/v1/activities/download_csv_format');
    };

    baseService.ActivitiesCsv = function(formData, date) {
      return $http.put(domain.name + '/api/v1/activities/import_activities_csv?date=' + date, formData, {
        headers: {
          'Content-Type': undefined
        }
      });
    };

    baseService.previewImport = function(activities) {
      return $http.post(BASE_ACTIVITY_URL + 'preview_import', { activities: activities });
    };

    baseService.importBatch = function(activities) {
      return $http.post(BASE_ACTIVITY_URL + 'import_batch', { activities: activities });
    };

    // Solo remueve lo que vino de Google.
    baseService.removeImportedWeek = function(weekStart) {
      return $http.delete(BASE_ACTIVITY_URL + 'remove_imported_week', {
        params: { week_start: weekStart }
      });
    };

    baseService.recentActivities = function(params) {
      return $http.get(domain.name + '/api/v1/activities/recent_activities', params );
    };

    baseService.copyPreviousWeek = function(params) {
      return $http.post(domain.name + '/api/v1/activities/copy_previous_week', params );
    };

    baseService.closeActivities = function(params) {
      return $http.put(domain.name + '/api/v1/activities/close_activities/', params );
    };

    baseService.openActivities = function(params) {
      return $http.put(domain.name + '/api/v1/activities/open_activities/', params );
    };

    baseService.closeMonthActivities = function(params) {
      return $http.put(domain.name + '/api/v1/activities/close_month_activities/', params );
    };

    baseService.openMonthActivities = function(params) {
      return $http.put(domain.name + '/api/v1/activities/open_month_activities/', params );
    };

    baseService.getAllTickets = function(params) {
      return $http.post(domain.name + '/api/v1/get_ticket_by_proyect', params );
    };

    baseService.validate = function(params) {
      return $http.post(domain.name + '/api/v1/activities/validate', params );
    };

    baseService.ReportActivities = function(params) {
      return $http.get(domain.name + '/api/v1/activities/reporting_activities.csv/', params );
    };

    baseService.classificationMetrics = function(params) {
      return $http.get(domain.name + '/api/v1/activities/classification_metrics', { params: params });
    };

    baseService.error = function(error) {
      baseService.baseError(error);
    };

    return baseService;
  }]);
